import {Component, Input} from '@angular/core';

export type WidgetColorType = 'success' | 'danger' | 'info' | 'caution' | 'primary-300';

@Component({
    selector: 'widget-info',
    templateUrl: './widget-info.component.html',
    standalone: false
})
export class WidgetInfoComponent {

  @Input() title!: string;
  @Input() text!: string;
  @Input() textSub!: string;
  @Input() icon!: string;
  @Input() color: WidgetColorType = 'success';

  get cssClass() {
    let colorStyle = `widget-${this.color}`;
    return [colorStyle];
  }

}
